//DefaultTable

import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { Button, Card, CardBody, CardTitle, CardFooter } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { FaPallet } from 'react-icons/fa';
import { FaBoxes } from 'react-icons/fa';
import { FaBox } from 'react-icons/fa';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'archivoBodega_Id';

export default function ArchivosBodega_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [selection, setSelection] = React.useState([]);
    const [sortModel, setSortModel] = React.useState([
        {
            field: keyField,
            //field: 'error',
            sort: 'desc',
        },
    ]);
    const intl = useIntl();

    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 60,
            type: 'number',
            hide: true
        },
        {
            field: 'createdDate',
            headerName: intl.formatMessage({ id: 'Fecha de importacion' }),
            editable: false,
            width: 150,
            renderCell: (params) => {
                //return params.row['createdDate'].slice(0, 10)
                return new Date(params.row['createdDate']).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit', hour: 'numeric', minute: 'numeric' }).replace(",","");
            }

        },
        {
            field: 'archivo',
            headerName: intl.formatMessage({ id: 'Archivo' }),
            editable: false,
            width: 160,
        },
        {
            field: 'paletas',
            headerName: intl.formatMessage({ id: 'Paletas' }),
            editable: false,
            width: 80,
        },
        {
            field: 'actions',
            headerName: () => {
                return (
                    <div>

                        <Tooltip title="Eliminar">
                            <IconButton className='RedButton GridButton' onClick={() => {
/*                                props.delete_onclick(params.row[keyField])*/
                            }}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                )
            },
            sortable: false,
            editable: false,
            filterable: false,
            align: 'center',
            width: 60,
            hide: false,
            renderCell: (params) => {
                return (
                    <div>
                        {/*<Tooltip title="Editar">*/}
                        {/*    <IconButton className='DarkBlueButton GridButton' onClick={() => {*/}
                        {/*        props.edit_onclick(params.row[keyField])*/}
                        {/*    }}>*/}
                        {/*        <EditIcon />*/}
                        {/*    </IconButton>*/}
                        {/*</Tooltip>*/}
                        <Tooltip title="Eliminar">
                            <IconButton className='RedButton GridButton' onClick={() => {
                                props.delete_onclick(params.row[keyField])
                            }}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                )
            },
        },

    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        archivoBodega_Id: false,
    });
    const onRowsSelectionHandler = (ids) => {
        const selectedRowsData = ids.map((id) => rows.find((row) => row[keyField] === id));
        console.log(selectedRowsData);
        setSelection(selectedRowsData);
    };
    return (

        <div>
            <Box sx={{
                height: 400, width: 555,
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 25, 50]}
                    pagination
                    disableRowSelectionOnClick
                    checkboxSelection 
                    onRowSelectionModelChange={(ids) => props.table_onselect(ids)}
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}

                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
